import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import brand from '@brand/brand.json'
import ar from './ar.json'
import en from './en.json'

export const resources = { ar: { translation: ar }, en: { translation: en } } as const

void i18n.use(initReactI18next).init({
  resources,
  lng: brand.locale,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
  document.documentElement.dir = i18n.dir(lng)
})

export default i18n
